import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { watchAppVersion } from './lib/app-version';
import './index.css';

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 10_000, refetchOnWindowFocus: false } } });

// Lo spot è una pagina statica in public/spot/: /spot e /spot/ la aprono senza passare dalla web app. Il rinvio sta qui
// perché sul server le cartelle di public arrivano alla SPA (try_files con $uri) finché le direttive nginx non sono
// installate, e perché il router usa solo l'hash.
if (/^\/spot\/?$/.test(window.location.pathname)) {
  window.location.replace('/spot/spot.html');
} else {
  watchAppVersion();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
}
